import axios from "axios";
import Environment from "./environment";

const env = Environment.getInstance();
const API_HOST = env.getApiHost();


export type CreateProductParams = {
  title: string,
  imageUrl?: string,
};

export type GetAllCreationsData = {
  id: string,
  title: string,
  imageUrl: string,
}

export type User = {
  displayName: string,
  email: string,
  expiresIn: string,
  idToken: string,
  kind: string,
  localId: string,
  profilePicture: string,
  refreshToken: string,
  registered: boolean,
};

export type UpdateProfileParams = {
  // email: TBD
  displayName: string,
};


class ApiService {
  private static _instance: ApiService;

  private constructor() { }

  public static getInstance() {
    return this._instance || (this._instance = new this());
  }

  async loginWithCredentials(email: string, password: string) {
    const result = await axios.post(`${API_HOST}/api/v1/account/login`, {
      email, password,
    }).catch((error) => {
      console.error({error})
      throw error?.response?.data || error;
    });
    const user = result.data.result;
    console.log('loginWithCredentials: the result is here:', { user });
    return user;
  }

  async registerWithCredentials(email: string, password: string): Promise<User> {
    const result = await axios.post(`${API_HOST}/api/v1/account/create`, {
      email, password,
    }).catch((error) => {
      console.error({error})
      throw error?.response?.data || error;
    });
    const user = result.data.result;
    console.log('registerWithCredentials: the result is here:', { user });
    return user;
  }

  async updateProfile(idToken: string, fields: UpdateProfileParams) {
    const result = await axios.post(`${API_HOST}/api/v1/account/update`, {
      displayName: fields.displayName,
    }, {
      headers: {
        [env.getAuthTokenHeaderKey()]: idToken,
      },
    }).catch((error) => {
      console.error({error})
      throw error?.response?.data ?? error;
    });
    const user = result.data.result;
    console.log('updateProfile: the result is here:', { user });
    return user;
  }

  async getProfile(idToken: string) {
    const result = await axios.get(`${API_HOST}/api/v1/account`, {
      headers: {
        [env.getAuthTokenHeaderKey()]: idToken,
      },
    }).catch((error) => {
      console.error({error})
      throw error?.response?.data ?? error;
    });
    const user = result.data.result;
    console.log('getProfile: the result is here:', { user });
    return user;
  }

  async getAllCreations(idToken: string): Promise<GetAllCreationsData[]> {
    const result = await axios.get(`${API_HOST}/api/v1/products`, {
      headers: {
        [env.getAuthTokenHeaderKey()]: idToken,
      },
    }).catch((error) => {
      console.error({error})
      throw error?.response?.data ?? error;
    });
    const results = result.data.results as GetAllCreationsData[];
    console.log('getAllCreations: the results are here:', { results });
    return results;
  }

  async createProduct(idToken: string, product: CreateProductParams) {
    const request = await axios.post(
      `${API_HOST}/api/v1/products/create`, product, {
        headers: {
          [env.getAuthTokenHeaderKey()]: idToken,
        },
      }).catch((error) => {
        console.error({error})
        throw error?.response?.data ?? error;
      });
      const result = request.data.result;
      console.log('createProduct: the result is here:', { result });
      return result;
    }

  }

  export default ApiService;